

class Request {

    defaultOptions() {
        return {
        	//Ajax request parameters
        	'method': 'POST',
        	'enctype': null,
            'cache': null,
            'contentType': null,
            'processData': null,
            'data': new FormData(),

        	//GraphQL parameters
        	'endpoint': App.get('graphqlEndpoint'),

        	//callbacks
        	'before': function(){},
        	'success': null,
        	'error': null,
        	'after': function(){},
        	'progress': function(e){},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.initialize();
    }

    initialize(){
    	return this;
    }

    buildData(){
    	return this.settings.data;
    }

    execute(){
    	var self = this;
    	this.before();

    	let data = this.buildData();
    	if(!data){
    		this.error("No query builded, execution failed",{});
    		console.log("request DATA BUILD FAILED");
    		return this.after();
    	}

		this.xhr = new XMLHttpRequest();
        this.xhr.withCredentials = false;
        this.xhr.open(this.settings.method,this.settings.endpoint,true);

        let apiToken =  window.App.get('graphqlToken');
        if(apiToken){
            this.xhr.setRequestHeader("Authorization","Bearer "+apiToken);
        }

        this.xhr.upload.onprogress = (e) => {
            self.settings.progress(e.loaded / e.total * 100);
        };

        this.xhr.onload = () => {

            if (this.xhr.status === 403) {
                self.error('HTTP Error: ' + this.xhr.status);
                return;
            }

            if (this.xhr.status < 200 || this.xhr.status >= 300) {
                self.error('HTTP Error: ' + this.xhr.status);
                return;
            }

            const json = JSON.parse(this.xhr.responseText);

            if (!json) {
                self.error('Invalid JSON: ' + this.xhr.responseText);
                return;
            }
            if(!json.data){
                self.error(window.translate('graphql.error.default'),json);
            }else{
                self.success(json);
            }
        };

        this.xhr.onloadend  = () => {
        	self.after();
        };

        this.xhr.send(data);
    }
    
    abort(){
        return this.xhr.abort();
    }

    before(){
    	return this.settings.before();
    }

    error(message, data){
    	if( this.settings.error){
    		return this.settings.error(message,data);
    	}
    }

    success(xhr){
        this.error("Success must be implemented",xhr);
    }

   	after(){
   		return this.settings.after();
   	}

}

module.exports = Request;

